module.exports = __webpack_public_path__ + "static/media/schody-do-kaple.fa113261.jpg";